/* eslint-disable react/display-name */
import DomainsList from './DomainsListController'

export default DomainsList
